import React from "react";

const Loader: React.FC = () => {
    return (
        <div className="d-flex align-items-baseline mb-4 message bot" id="chatLoader">
            <div className="pe-2">
                <div className="chat-typing">
                    <i></i>
                    <i></i>
                    <i></i>
                </div>
            </div>
        </div>
    );
};

export default Loader;
